import React from 'react';
import SpinnerIcon from './spinnerIcon';

const Spinner = ({ message }) => {
  const styled = {
    background: 'rgba(0, 0, 0, .25)',
    height: '100vh',
    width: '100vw',
    position: 'fixed'
  };

  return (
    <div className="spinner" style={styled}>
      <SpinnerIcon />
      <span>{message}</span>
    </div>
  );
};

export default Spinner;
